import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class HorizontalDotsIcon extends BaseIcon {
  getChildren = () => [
    <path fill={ this.getColor() } d="M2,6A2,2,0,1,0,4,8,2,2,0,0,0,2,6Z"/>,
    <path fill={ this.getColor() } d="M8,6a2,2,0,1,0,2,2A2,2,0,0,0,8,6Z"/>,
    <path fill={ this.getColor() } d="M14,6a2,2,0,1,0,2,2A2,2,0,0,0,14,6Z"/>
    ]
  getViewBox = () => '0 0 16 16'
}
